export const NORMAL = 50
export const LARGE = 80
export const BUTTON = 22
